import React, { Component } from "react";
import { BrandTextLogo } from "../_components/common/statelessView";
import { Link } from "react-router-dom";
import { LOGIN } from "../_utils/routes";
import { IntercomCustomIcon } from "../_components/styled/home/statelessView";
import { withTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
class TldrBase extends Component {
  render() {
    const { showBackgroundImage, heading, subheading, wrapperClassName, t } =
      this.props;

    return (
      <div className={`${wrapperClassName} wrapper`}>
        {showBackgroundImage && <div className="tldr-dark-overlay" />}
        <div className="login-box">
          <Box className="login-card-body" p="1.25rem">
            <div className="login-logo">
              <Link to={LOGIN}>
                <BrandTextLogo height={60} width={160} />
              </Link>
            </div>
            <Box textAlign="center" className="heading">
              {heading}
            </Box>
            <Box textAlign="center">{subheading}</Box>

            {this.props.children}
          </Box>
          <Box className="input-group copyright" mt={3}>
            <div>
              {t("login.copyright", { year: new Date().getFullYear() })}
            </div>
          </Box>
        </div>
        <IntercomCustomIcon position={"absolute"} />
      </div>
    );
  }
}

export default withTranslation(["auth"])(TldrBase);
